import React, { useState } from "react";
import { Toast, Tooltip, OverlayTrigger } from "react-bootstrap";
import AvatarSelection from "./AvatarSelection";

export default function MultiSceneSelection({
	loadedAvatars,
	value = [],
	onChange,
	loadedScenes,
	onBlur,
	error,
	touched,
	locked,
	producerView,
	adminView,
}) {
	const [scenes, setScenes] = useState(loadedScenes || []);
	const [showToast, setShowToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");

	const handleShowToast = (message) => {
		setToastMessage(message);
		setShowToast(true);
	};

	const handleAvatarSelected = ({ avatarId, lookId, thumbnail }) => {
		// Only add scenes when both lookId and thumbnail are valid (not null)
		// This prevents adding scenes when just clicking on an avatar with multiple scenes
		if (!lookId || !thumbnail) {
			return;
		}

		// Check if the scene already exists
		const sceneExists = scenes.some(
			(scene) => scene.avatarId === avatarId && scene.lookId === lookId
		);

		if (sceneExists) {
			handleShowToast("Scene already added!");
			return;
		}

		handleShowToast("Scene Added!");
		const newScenes = [
			...scenes,
			{
				avatarId: avatarId,
				lookId: lookId,
				thumbnail: thumbnail,
			},
		];
		setScenes(newScenes);
		if (onChange) {
			onChange(newScenes);
		}
		console.log("Scenes:", newScenes);
		//handleCloseModal();
	};

	const handleRemoveScene = (index) => {
		const newScenes = scenes.filter((_, i) => i !== index);
		setScenes(newScenes);
		if (onChange) {
			onChange(newScenes);
		}
		console.log("Scenes:", newScenes);
	};

	return (
		<div>
			{!locked && (
				<AvatarSelection
					value={{}}
					onChange={handleAvatarSelected}
					loadedAvatars={loadedAvatars}
				/>
			)}
			{scenes.length > 0 && <p>Selected Scenes</p>}
			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					gap: "1rem",
					padding: "0.5rem 0",
				}}
			>
				{scenes.map((scene, index) => (
					<div
						key={index}
						style={{
							position: "relative",
							width: "auto",
							height: "100px",
							borderRadius: "8px",
							overflow: "hidden",
						}}
						onMouseEnter={(e) => {
							const overlay = e.currentTarget.querySelector(".overlay-div");
							if (overlay) overlay.style.opacity = 1;
						}}
						onMouseLeave={(e) => {
							const overlay = e.currentTarget.querySelector(".overlay-div");
							if (overlay) overlay.style.opacity = 0;
						}}
					>
						<img
							src={scene.thumbnail}
							alt="Scene Thumbnail"
							style={{
								width: "100%",
								height: "100%",
								objectFit: "cover",
							}}
						/>

						{!locked && (
							<div
								className="overlay-div"
								style={{
									position: "absolute",
									top: 0,
									left: 0,
									width: "100%",
									height: "100%",
									backgroundColor: "rgba(255, 255, 255, 0.64)",
									opacity: 0,
									transition: "opacity 0.1s",
								}}
							>
								<div
									style={{
										position: "absolute",
										top: "0px",
										right: "6px",
										color: "black",
										fontSize: "16px",
										fontWeight: "bold",
										cursor: "pointer",
									}}
									onClick={() => handleRemoveScene(index)}
								>
									X
								</div>
							</div>
						)}
					</div>
				))}
				{locked && (adminView || producerView) && (
					<OverlayTrigger
						placement="top"
						overlay={<Tooltip id="copyTooltip">Copy avatar and scene data to clipboard</Tooltip>}
					>
						<button
							type="button"
							style={{ color: "white", backgroundColor: "#cccccc", borderRadius: "8px" }}
							onClick={() => {
								navigator.clipboard.writeText(JSON.stringify(scenes));
								handleShowToast("Scenes copied to clipboard!");
							}}
						>
							Copy Data
						</button>
					</OverlayTrigger>
				)}
			</div>

			<div style={{ position: "fixed", top: 20, right: 20, zIndex: 9999 }}>
				<Toast
					show={showToast}
					onClose={() => setShowToast(false)}
					delay={3000}
					autohide
				>
					<Toast.Header>
						<strong className="me-auto">{toastMessage}</strong>
					</Toast.Header>
				</Toast>
			</div>
		</div>
	);
}
